"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    tagPickerListClassNames: function() {
        return tagPickerListClassNames;
    },
    useTagPickerListStyles_unstable: function() {
        return useTagPickerListStyles_unstable;
    }
});
const _react = require("@griffel/react");
const tagPickerListClassNames = {
    root: 'fui-TagPickerList'
};
/**
 * Styles for the root slot
 */ const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    root: {
        E5pizo: "f1hg901r",
        Beyfa6y: 0,
        Bbmb7ep: 0,
        Btl43ni: 0,
        B7oj6ja: 0,
        Dimara: "ft85np5",
        Bxyxcbc: "fmmk62d",
        B7ck84d: "f1ewtqcl"
    },
    collapsed: {
        mc9l5x: "fjseox"
    }
}, {
    d: [
        ".f1hg901r{box-shadow:var(--shadow16);}",
        [
            ".ft85np5{border-radius:var(--borderRadiusMedium);}",
            {
                p: -1
            }
        ],
        ".fmmk62d{max-height:80vh;}",
        ".f1ewtqcl{box-sizing:border-box;}",
        ".fjseox{display:none;}"
    ]
});
const useTagPickerListStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(tagPickerListClassNames.root, styles.root, !state.open && styles.collapsed, state.root.className);
    return state;
}; //# sourceMappingURL=useTagPickerListStyles.styles.js.map
